import { render, staticRenderFns } from "./FormSaver.vue?vue&type=template&id=74fea670&"
import script from "./FormSaver.vue?vue&type=script&lang=js&"
export * from "./FormSaver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports